import loadData from './load-data';
import util from './_utils';
import core_viz from './core-viz';
// import track from './track';
import love_hate_steps from './love-hate-steps';
import lang from './lang';
import filters from './filters';

const combine = false;

const container = d3.select('.graphic__chart'),
	rightPanel = d3.select('.graphic__right'),
	header = d3.select('.viz-header'),
	svg = container.select('.svg__love-hate'),
	g = svg.select('.love-hate'),
	g_bubbles = g.select('.lh-bubbles'),
	g_text = g.select('.lh-text'),
	g_voronoi = g.select('.lh-voronoi'),
	g_progress = g.select('.lh-progress');

let margin, x, y, r, ovrR, barX, font, ovrFont, w, h;

let progressR, iconW, tooltipW = 120;

let steps, baseData, stepsData, data, vizParameters, isMobile, isTablet, drawn = false;

const skips = [`When it's time to get ready to run`, `Uploading my activity to Strava`],
	skipSteps = [`Planning my run route`, `Midpoint`, `Running uphill`, `Knowing it's almost over`, `Post-run food or drink`, `Receiving kudos afterwards`];

let love, loveValue, tolerate, tolerateValue, hate, hateValue, progress, progressActive, bars, icons, voronoi;

const labelsAtTop = false,
	scrollIntoView = true;

let loveText, tolerateText, hateText;

const cols = {
		love: 2.5,
		tolerate: 5,
		hate: 7.5,
		icon: 1
	},
	selectors = {
		age: 'Total',
		sex: 'Total',
		nationality: 'Total'
	},
	duration = {
		fast: 250,
		medium: 500,
		slow: 1000,
		reallySlow: 5000
	};

let step = 0,
	prevStep = 0;

function next(index, fromMenu) {
	prevStep = step;
	step = index + 1;

	if (step != 4) {
		selectors.age = 'Total';
		selectors.sex = 'Total';
		selectors.nationality = 'Total';
		filters.set(null, null, null);
	}

	if (!drawn) {
		draw(fromMenu);
	} else {
		if (step != 0 && step != 4) update();
		if (step == 4) drawAll();
	}
	util.setStoryLocation('love-hate', step);
	filters.toggle('love-hate', step);
}

function filter(selectedFilters) {
	selectors.age = selectedFilters.age;
	selectors.sex = selectedFilters.sex;
	selectors.nationality = selectedFilters.nationality;

	drawAll();
}

function init() {
	return new Promise((resolve, reject) => {
		Promise.all([
			loadData(['love_hate.csv', 'love_hate_steps.csv']),
		]).then(function(result) {
			baseData = util.parseData(result[0][0]);
			steps = result[0][1];

			baseData = baseData.filter(d => skips.indexOf(d.Phase) < 0);
			stepsData = baseData.filter(d => skipSteps.indexOf(d.Phase) < 0);

			stepsData.forEach(d => {
				d.index = +steps.filter(s => s['Step Name'] == d.Phase)[0].Index;
			})

			setup();
			resolve();
		}).catch(function(err) {
			console.log(err);
		})
	})
}

function setup(resize = false) {
	isMobile = util.isMobile();
	isTablet = util.isTablet();
	vizParameters = getVizParameters();

	margin = {
		top: vizParameters.headerH + (isMobile ? 20 : 50),
		right: isMobile ? 30 : 0,
		bottom: isMobile ? 20 : 50,
		left: isMobile ? 30 : 45,
		rightAxis: getRightMargin()
	}

	progressR = isMobile ? 5 : 8;
	iconW = isMobile ? 15 : 25;

	w = vizParameters.outerW - margin.right - margin.left;
	h = vizParameters.outerH - margin.top - margin.bottom;

	let rMax = vizParameters.outerW * (isMobile ? .2 : .33);

	x = d3.scaleLinear().domain([0, 10]).range([0, w]);
	y = d3.scaleLinear().domain([0, 100]).range([0, h]);

	r = d3.scaleSqrt().domain([0, combine ? 1 : .63]).range([0, rMax]);
	ovrR = d3.scaleSqrt().domain([0, combine ? 1 : .63]).range([0, isMobile ? 50 : 100]);

	barX = d3.scaleSqrt().domain([0, combine ? 1 : .63]).range([0, w / 2]);

	font = d3.scaleSqrt().domain([0, combine ? 1 : .63]).range([12, isMobile ? 36 : 72]);
	ovrFont = d3.scaleSqrt().domain([0, combine ? 1 : .63]).range([12, isMobile ? 24 : 54]);

	g.attr('transform', `translate(${margin.left}, ${margin.top})`);

	if (resize) resizeLH();
}

function draw(fromMenu) {
	setTimeout(() => {
		core_viz.moveMass('outOfView', false);
	}, duration.fast);

	drawn = true;
	data = filterData(stepsData);

	const bubbleParameters = getBubbleParameters();

	love = g_bubbles.selectAll('.love-bubble').data([data[0]]);
	tolerate = g_bubbles.selectAll('.tolerate-bubble').data([data[0]]);
	hate = g_bubbles.selectAll('.hate-bubble').data([data[0]]);

	progress = g_progress.selectAll('.progress').data([1, 2, 3, 4]);
	progressActive = g_progress.selectAll('.progress--active').data([{
		1: 0,
		2: 1,
		3: 2,
		4: 3
	}]);
	love.enter()
		.append('circle').attr('class', 'love-bubble')
		.attr('cx', bubbleParameters.love.x).attr('cy', bubbleParameters.love.y).attr('r', bubbleParameters.love.r)
		.transition().duration(fromMenu ? 0 : duration.fast)
		.attr('cx', x(cols.love)).attr('cy', y(isMobile ? 200 : 75)).attr('r', util.randomNumber(20, 50));

	tolerate.enter()
		.append('circle').attr('class', 'tolerate-bubble')
		.attr('cx', bubbleParameters.tolerate.x).attr('cy', bubbleParameters.tolerate.y).attr('r', bubbleParameters.tolerate.r)
		.transition().duration(fromMenu ? 0 : duration.fast)
		.attr('cx', x(cols.tolerate)).attr('cy', y(isMobile ? 200 : 75)).attr('r', util.randomNumber(20, 50));

	hate.enter()
		.append('circle').attr('class', 'hate-bubble')
		.attr('cx', bubbleParameters.hate.x).attr('cy', bubbleParameters.hate.y).attr('r', bubbleParameters.hate.r)
		.transition().duration(fromMenu ? 0 : duration.fast)
		.attr('cx', x(cols.hate)).attr('cy', y(isMobile ? 200 : 75)).attr('r', util.randomNumber(20, 50));

	progress.enter()
		.append('circle').attr('class', 'progress')
		.attr('cy', (d, i) => h / 2 - (progressR * 8) + (i * (progressR * 4))).attr('r', progressR)
		.style('opacity', 0)
		.on('click', progressClick);

	progressActive.enter()
		.append('circle').attr('class', 'progress--active')
		.attr('cx', x(0)).attr('cy', d => h / 2 - (progressR * 8) + (d[1] * (progressR * 4)))
		.attr('r', progressR * .5)
		.style('opacity', 0);

	if (labelsAtTop) {
		g_text.append('text')
			.attr('class', 'lh-axis-label--column lh-axis-label--column__bg')
			.attr('id', 'lh-axis-label-love-bg')
			.attr('x', x(cols.love)).attr('y', y(isMobile ? 0 : 0))
			.text(lang.translateViz('love-hate', 'Axis--Love'))
			.style('opacity', 0)
			.transition().duration(duration.slow).delay(duration.slow)
			.style('opacity', 1);

		g_text.append('text')
			.attr('class', 'lh-axis-label--column lh-axis-label--column__bg')
			.attr('id', 'lh-axis-label-tolerate-bg')
			.attr('x', x(cols.tolerate)).attr('y', y(isMobile ? 0 : 0))
			.text(lang.translateViz('love-hate', 'Axis--Tolerate'))
			.style('opacity', 0)
			.transition().duration(duration.slow).delay(duration.slow)
			.style('opacity', 1);

		g_text.append('text')
			.attr('class', 'lh-axis-label--column lh-axis-label--column__bg')
			.attr('id', 'lh-axis-label-hate-bg')
			.attr('x', x(cols.hate)).attr('y', y(isMobile ? 0 : 0))
			.text(lang.translateViz('love-hate', 'Axis--Hate'))
			.style('opacity', 0)
			.transition().duration(duration.slow).delay(duration.slow)
			.style('opacity', 1);

		g_text.append('text')
			.attr('class', 'lh-axis-label--column')
			.attr('id', 'lh-axis-label-love')
			.attr('x', x(cols.love)).attr('y', y(isMobile ? 0 : 0))
			.text(lang.translateViz('love-hate', 'Axis--Love'))
			.style('opacity', 0)
			.transition().duration(duration.slow).delay(duration.slow)
			.style('opacity', 1);

		g_text.append('text')
			.attr('class', 'lh-axis-label--column')
			.attr('id', 'lh-axis-label-tolerate')
			.attr('x', x(cols.tolerate)).attr('y', y(isMobile ? 10 : 5))
			.text(lang.translateViz('love-hate', 'Axis--Tolerate'))
			.style('opacity', 0)
			.transition().duration(duration.slow).delay(duration.slow)
			.style('opacity', 1);

		g_text.append('text')
			.attr('class', 'lh-axis-label--column')
			.attr('id', 'lh-axis-label-hate')
			.attr('x', x(cols.hate)).attr('y', y(isMobile ? 0 : 0))
			.text(lang.translateViz('love-hate', 'Axis--Hate'))
			.style('opacity', 0)
			.transition().duration(duration.slow).delay(duration.slow)
			.style('opacity', 1);
	}

	if (fromMenu) update();

}

function update() {
	data = filterData(stepsData);
	const stepData = [data[step - 1]];

	love = g_bubbles.selectAll('.love-bubble').data(stepData, d => d.Phase);
	tolerate = g_bubbles.selectAll('.tolerate-bubble').data(stepData, d => d.Phase);
	hate = g_bubbles.selectAll('.hate-bubble').data(stepData, d => d.Phase);

	loveValue = g_text.selectAll('.lh-label--value--love').data(stepData, d => d.Phase);
	tolerateValue = g_text.selectAll('.lh-label--value--tolerate').data(stepData, d => d.Phase);
	hateValue = g_text.selectAll('.lh-label--value--hate').data(stepData, d => d.Phase);

	progress = g_progress.selectAll('.progress');
	progressActive = g_progress.selectAll('.progress--active');

	icons = g_bubbles.selectAll('.lh-final-icon').data([]);
	// bars = g_bubbles.selectAll('.lh-bar').data([]);
	voronoi = g_voronoi.selectAll('.lh-voronoi').data([]);

	let activeStep = getActiveStep(step);

	love.exit()
		.transition().duration(duration.medium).delay((d, i) => i * 50)
		.attr('r', 0)
		.attr('cy', d => prevStep < step ? y(0) - r(calcLove(d)) : y(isMobile ? 210 : 105) + r(calcLove(d))).remove();

	love.enter()
		.append('circle').attr('class', 'love-bubble')
		.attr('cx', x(cols.love)).attr('cy', d => scrollIntoView ? (prevStep < step ? y(isMobile ? 210 : 105) + r(calcLove(d)) : y(0) - r(calcLove(d))) : y(50))
		// .attr('r', d => scrollIntoView ? r(calcLove(d)) : 0)
		.attr('r', 0)
		.transition().duration(duration.medium).delay((scrollIntoView ? 0 : duration.medium) + util.randomNumber(100, 200))
		.attr('cy', y(50)).attr('r', d => r(calcLove(d)));

	love.merge(love)
		.transition().duration(duration.medium).delay((d, i) => i * 50)
		.attr('cy', y(50)).attr('r', d => r(calcLove(d)));

	loveValue.enter()
		.append('text').attr('class', 'lh-label lh-label--value lh-label--value--love')
		.attr('x', x(cols.love)).attr('y', y(50)).attr('dy', labelsAtTop ? 14 : 4)
		.style('font-size', d => `${font(calcLove(d))}px`)
		.text(d => formatPercent(calcLove(d)))
		.style('opacity', 0)
		.transition().duration(duration.slow).delay(duration.medium)
		.style('opacity', 1);

	loveValue.exit()
		.transition().duration(duration.fast).style('opacity', 0)
		.remove();

	tolerate.exit()
		.transition().duration(duration.medium).delay((d, i) => i * 50)
		.attr('r', 0)
		.attr('cy', d => prevStep < step ? y(0) - r(d.Tolerate) : y(isMobile ? 210 : 105) + r(d.Tolerate)).remove();

	tolerate.enter()
		.append('circle').attr('class', 'tolerate-bubble')
		.attr('cx', x(cols.tolerate)).attr('cy', d => scrollIntoView ? (prevStep < step ? y(isMobile ? 210 : 105) + r(d.Tolerate) : y(0) - r(calcLove(d))) : y(50))
		// .attr('r', d => scrollIntoView ? r(calcLove(d)) : 0)
		.attr('r', 0)
		.transition().duration(duration.medium).delay((scrollIntoView ? 0 : duration.medium) + util.randomNumber(100, 200))
		.attr('cy', y(50)).attr('r', d => r(d.Tolerate));

	tolerate.merge(tolerate)
		.transition().duration(duration.medium).delay((d, i) => i * 50)
		.attr('cy', y(50)).attr('r', d => r(d.Tolerate));

	tolerateValue.enter()
		.append('text').attr('class', 'lh-label lh-label--value lh-label--value--tolerate')
		.attr('x', x(cols.tolerate)).attr('y', y(50)).attr('dy', labelsAtTop ? 14 : 4)
		.style('font-size', d => `${font(d.Tolerate)}px`)
		.text(d => formatPercent(d.Tolerate))
		.style('opacity', 0)
		.transition().duration(duration.slow).delay(duration.medium)
		.style('opacity', 1);

	tolerateValue.exit()
		.transition().duration(duration.fast).style('opacity', 0)
		.remove();

	hate.exit()
		.transition().duration(duration.medium).delay((d, i) => i * 50)
		.attr('r', 0)
		.attr('cy', d => prevStep < step ? y(0) - r(calcHate(d)) : y(isMobile ? 210 : 105) + r(calcHate(d))).remove();

	hate.enter()
		.append('circle').attr('class', 'hate-bubble')
		.attr('cx', x(cols.hate)).attr('cy', d => scrollIntoView ? (prevStep < step ? y(isMobile ? 210 : 105) + r(calcHate(d)) : y(0) - r(calcLove(d))) : y(50))
		// .attr('r', d => scrollIntoView ? r(calcLove(d)) : 0)
		.attr('r', 0)
		.transition().duration(duration.medium).delay((scrollIntoView ? 0 : duration.medium) + util.randomNumber(100, 200))
		.attr('cy', y(50)).attr('r', d => r(calcHate(d)));

	hate.merge(hate)
		.transition().duration(duration.medium).delay((d, i) => i * 50)
		.attr('cy', y(50)).attr('r', d => r(calcHate(d)));

	hateValue.enter()
		.append('text').attr('class', 'lh-label lh-label--value lh-label--value--hate')
		.attr('x', x(cols.hate)).attr('y', y(50)).attr('dy', labelsAtTop ? 14 : 4)
		.style('font-size', d => `${font(calcHate(d))}px`)
		.text(d => formatPercent(calcHate(d)))
		.style('opacity', 0)
		.transition().duration(duration.slow).delay(duration.medium)
		.style('opacity', 1);

	hateValue.exit()
		.transition().duration(duration.fast).style('opacity', 0)
		.remove();

	if (!labelsAtTop) {
		loveText = g_text.selectAll('.lh-label--text--love').data(stepData, d => d.Phase);
		tolerateText = g_text.selectAll('.lh-label--text--tolerate').data(stepData, d => d.Phase);
		hateText = g_text.selectAll('.lh-label--text--hate').data(stepData, d => d.Phase);

		loveText.enter()
			.append('text').attr('class', 'lh-label lh-label--value lh-label--value--love')
			.attr('x', x(cols.love)).attr('y', y(50)).attr('dy', isMobile ? 24 : 32)
			.text(lang.translateViz('love-hate', 'Axis--Love'))
			.style('opacity', 0)
			.transition().duration(duration.slow).delay(duration.medium)
			.style('opacity', 1);

		loveText.exit()
			.transition().duration(duration.fast).style('opacity', 0)
			.remove();

		tolerateText.enter()
			.append('text').attr('class', 'lh-label lh-label--value lh-label--value--tolerate')
			.attr('x', x(cols.tolerate)).attr('y', y(50)).attr('dy', isMobile ? 24 : 32)
			.text(lang.translateViz('love-hate', 'Axis--Tolerate'))
			.style('opacity', 0)
			.transition().duration(duration.slow).delay(duration.medium)
			.style('opacity', 1);

		tolerateText.exit()
			.transition().duration(duration.fast).style('opacity', 0)
			.remove();

		hateText.enter()
			.append('text').attr('class', 'lh-label lh-label--value lh-label--value--hate')
			.attr('x', x(cols.hate)).attr('y', y(50)).attr('dy', isMobile ? 24 : 32)
			.text(lang.translateViz('love-hate', 'Axis--Hate'))
			.style('opacity', 0)
			.transition().duration(duration.slow).delay(duration.medium)
			.style('opacity', 1);

		hateText.exit()
			.transition().duration(duration.fast).style('opacity', 0)
			.remove();
	}

	progress.merge(progress)
		.transition().duration(duration.fast).delay((d, i) => i * 50)
		.style('opacity', 1);

	progressActive.merge(progressActive)
		.transition().duration(duration.fast)
		.attr('cy', d => h / 2 - (progressR * 8) + (d[activeStep] * (progressR * 4))).attr('r', progressR * .5)
		.style('opacity', 1);

	icons.exit().transition().duration(duration.fast).delay((d, i) => i * 25).style('opacity', 0).remove();
	// bars.exit().transition().duration(duration.fast).delay((d, i) => i * 25).attr('x2', d => x(cols.icon) + (d.Love > d.Hate ? -iconW : iconW)).remove();
	voronoi.exit().remove();

	g_text.selectAll('.lh-axis--final').transition().duration(duration.medium).style('opacity', 0).remove();

	if (!labelsAtTop) g.selectAll('.lh-axis-label--column').transition().duration(duration.fast).style('opacity', 0).remove();
}

function drawAll() {
	data = filterData(baseData);
	love = g_bubbles.selectAll('.love-bubble').data(data, d => d.Phase);
	tolerate = g_bubbles.selectAll('.tolerate-bubble').data(data, d => d.Phase);
	hate = g_bubbles.selectAll('.hate-bubble').data(data, d => d.Phase);

	loveValue = g_text.selectAll('.lh-label--value--love').data([]);
	tolerateValue = g_text.selectAll('.lh-label--value--tolerate').data([]);
	hateValue = g_text.selectAll('.lh-label--value--hate').data([]);

	progressActive = g_progress.selectAll('.progress--active');

	icons = g_bubbles.selectAll('.lh-final-icon').data(data, d => d.Phase);
	// bars = g_bubbles.selectAll('.lh-bar').data(data, d => d.Phase);
	voronoi = g_voronoi.selectAll('.lh-voronoi').data(data, d => d.Phase);

	let activeStep = getActiveStep(step);

	loveValue.exit().transition().duration(duration.fast).style('opacity', 0).remove();
	tolerateValue.exit().transition().duration(duration.fast).style('opacity', 0).remove();
	hateValue.exit().transition().duration(duration.fast).style('opacity', 0).remove();

	if (!labelsAtTop) {
		loveText = g_text.selectAll('.lh-label--text--love').data([]);
		tolerateText = g_text.selectAll('.lh-label--text--tolerate').data([]);
		hateText = g_text.selectAll('.lh-label--text--hate').data([]);

		loveText.exit().transition().duration(duration.fast).style('opacity', 0).remove();

		tolerateText.exit().transition().duration(duration.fast).style('opacity', 0).remove();

		hateText.exit().transition().duration(duration.fast).style('opacity', 0).remove();
	}

	love.enter().append('circle')
		.attr('class', 'love-bubble')
		.attr('cx', x(cols.love)).attr('cy', (d, i) => y((i / data.length) * 100) + (y((1 / data.length) * 100)) / 2)
		.attr('r', 0)
		.transition().duration(duration.medium).delay((d, i) => i * 75)
		.attr('r', d => ovrR(calcLove(d)));

	love.merge(love)
		.transition().duration(duration.medium).delay(duration.fast)
		.attr('cy', (d, i) => y((i / data.length) * 100) + (y((1 / data.length) * 100)) / 2)
		.attr('r', d => ovrR(calcLove(d)));

	tolerate.enter().append('circle')
		.attr('class', 'tolerate-bubble')
		.attr('cx', x(cols.tolerate)).attr('cy', (d, i) => y((i / data.length) * 100) + (y((1 / data.length) * 100)) / 2)
		.attr('r', 0)
		.transition().duration(duration.medium).delay((d, i) => i * 75)
		.attr('r', d => ovrR(d.Tolerate));

	tolerate.merge(tolerate)
		.transition().duration(duration.medium).delay(duration.fast)
		.attr('cy', (d, i) => y((i / data.length) * 100) + (y((1 / data.length) * 100)) / 2)
		.attr('r', d => ovrR(d.Tolerate));

	hate.enter().append('circle')
		.attr('class', 'hate-bubble')
		.attr('cx', x(cols.hate)).attr('cy', (d, i) => y((i / data.length) * 100) + (y((1 / data.length) * 100)) / 2)
		.attr('r', 0)
		.transition().duration(duration.medium).delay((d, i) => i * 75)
		.attr('r', d => ovrR(calcHate(d)));

	hate.merge(hate)
		.transition().duration(duration.medium).delay(duration.fast)
		.attr('cy', (d, i) => y((i / data.length) * 100) + (y((1 / data.length) * 100)) / 2)
		.attr('r', d => ovrR(calcHate(d)));

	progressActive.merge(progressActive)
		.transition().duration(duration.fast)
		.attr('cy', d => h / 2 - (progressR * 8) + (d[activeStep] * (progressR * 4))).attr('r', progressR * .5);

	icons.enter()
		.append('svg:image').attr('class', 'lh-final-icon')
		.attr('xlink:href', (d, i) => `./assets/images/icons/strava-${i + 1}.svg`)
		.attr('x', x(cols.icon) - iconW / 2).attr('y', (d, i) => y((i / data.length) * 100) + (y((1 / data.length) * 100)) / 2 - iconW / 2)
		.attr('width', iconW)
		.attr('height', iconW)
		.style('opacity', 0)
		.transition().duration(duration.slow).delay((d, i) => i * 50)
		.style('opacity', 1);

	voronoi.enter().append('rect')
		.attr('class', 'lh-voronoi')
		.attr('x', x(0)).attr('y', (d, i) => y((i / data.length) * 100))
		.attr('width', w).attr('height', (d, i) => y((1 / data.length) * 100))
		.style('pointer-events', 'none')
		.on('mouseover', mouseover)
		.on('mouseout', mouseout)
		.transition().delay(duration.slow)
		.style('pointer-events', 'all');

	voronoi.merge(voronoi)
		.style('pointer-events', 'none')
		.on('mouseover', mouseover)
		.on('mouseout', mouseout)
		.transition().delay(duration.slow)
		.style('pointer-events', 'all');

	// bars.enter()
	// 	.append('line').attr('class', 'lh-bar')
	// 	.attr('x1', d => x(4.5) + (d.Love > d.Hate ? -iconW : iconW)).attr('x2', d => x(4.5) + (d.Love > d.Hate ? -iconW : iconW))
	// 	.attr('y1', (d, i) => y((i / data.length) * 100) + (y((1 / data.length) * 100)) / 2).attr('y2', (d, i) => y((i / data.length) * 100) + (y((1 / data.length) * 100)) / 2)
	// 	.style('stroke', d => d.Love > d.Hate ? '#F8621F' : '#1F63F3')
	// 	.transition().duration(duration.slow).delay((d, i) => i * 50)
	// 	.attr('x2', d => x(4.5) + (d.Love > d.Hate ? -iconW : iconW) + (d.Love > d.Hate ? -barX(d.Love) : barX(d.Hate)));
	g_text.append('text')
		.attr('class', 'lh-axis--final lh-axis-label--small')
		.attr('id', 'lh-axis-final-start')
		.attr('x', w - margin.rightAxis + (isMobile ? margin.right : 0) - 60).attr('y', y((0 / data.length) * 100) + (y((1 / data.length) * 100)) / 2)
		.attr('dy', isMobile ? 4 : 5)
		.text(lang.translateViz('love-hate', `Axis--Start`))
		.style('opacity', 0)
		.transition().duration(duration.fast)
		.style('opacity', 1);

	g_text.append('text')
		.attr('class', 'lh-axis--final lh-axis-label--small')
		.attr('id', 'lh-axis-final-finish')
		.attr('x', w - margin.rightAxis + (isMobile ? margin.right : 0) - 60).attr('y', y((8 / data.length) * 100) + (y((1 / data.length) * 100)) / 2)
		.attr('dy', isMobile ? 4 : 5)
		.text(lang.translateViz('love-hate', `Axis--Finish`))
		.style('opacity', 0)
		.transition().duration(duration.fast)
		.style('opacity', 1);

	g_text.append('line')
		.attr('class', 'lh-axis--final lh-axis-line')
		.attr('id', 'lh-axis-final-start-line')
		.attr('x1', w - margin.rightAxis + (isMobile ? margin.right : 0) - 60).attr('x2', isMobile ? x(7.5) + 5 : x(8))
		.attr('y1', y((0 / data.length) * 100) + (y((1 / data.length) * 100)) / 2).attr('y2', y((0 / data.length) * 100) + (y((1 / data.length) * 100)) / 2)
		.style('opacity', 0)
		.transition().duration(duration.fast)
		.style('opacity', 1);

	g_text.append('line')
		.attr('class', 'lh-axis--final lh-axis-line')
		.attr('id', 'lh-axis-final-finish-line')
		.attr('x1', w - margin.rightAxis + (isMobile ? margin.right : 0) - 60).attr('x2', isMobile ? x(7.5) + 5 : x(8))
		.attr('y1', y((8 / data.length) * 100) + (y((1 / data.length) * 100)) / 2).attr('y2', y((8 / data.length) * 100) + (y((1 / data.length) * 100)) / 2)
		.style('opacity', 0)
		.transition().duration(duration.fast)
		.style('opacity', 1);

	if (!labelsAtTop) {
		g_text.append('text')
			.attr('class', 'lh-axis-label--column lh-axis-label--column__bg')
			.attr('id', 'lh-axis-label-love-bg')
			.attr('x', x(cols.love)).attr('y', y(isMobile ? 0 : 0))
			.text(lang.translateViz('love-hate', 'Axis--Love'))
			.style('opacity', 0)
			.transition().duration(duration.slow).delay(duration.slow)
			.style('opacity', 1);

		g_text.append('text')
			.attr('class', 'lh-axis-label--column lh-axis-label--column__bg')
			.attr('id', 'lh-axis-label-tolerate-bg')
			.attr('x', x(cols.tolerate)).attr('y', y(isMobile ? 0 : 0))
			.text(lang.translateViz('love-hate', 'Axis--Tolerate'))
			.style('opacity', 0)
			.transition().duration(duration.slow).delay(duration.slow)
			.style('opacity', 1);

		g_text.append('text')
			.attr('class', 'lh-axis-label--column lh-axis-label--column__bg')
			.attr('id', 'lh-axis-label-hate-bg')
			.attr('x', x(cols.hate)).attr('y', y(isMobile ? 0 : 0))
			.text(lang.translateViz('love-hate', 'Axis--Hate'))
			.style('opacity', 0)
			.transition().duration(duration.slow).delay(duration.slow)
			.style('opacity', 1);

		g_text.append('text')
			.attr('class', 'lh-axis-label--column')
			.attr('id', 'lh-axis-label-love')
			.attr('x', x(cols.love)).attr('y', y(isMobile ? 0 : 0))
			.text(lang.translateViz('love-hate', 'Axis--Love'))
			.style('opacity', 0)
			.transition().duration(duration.slow).delay(duration.slow)
			.style('opacity', 1);

		g_text.append('text')
			.attr('class', 'lh-axis-label--column')
			.attr('id', 'lh-axis-label-tolerate')
			.attr('x', x(cols.tolerate)).attr('y', y(isMobile ? 0 : 0))
			.text(lang.translateViz('love-hate', 'Axis--Tolerate'))
			.style('opacity', 0)
			.transition().duration(duration.slow).delay(duration.slow)
			.style('opacity', 1);

		g_text.append('text')
			.attr('class', 'lh-axis-label--column')
			.attr('id', 'lh-axis-label-hate')
			.attr('x', x(cols.hate)).attr('y', y(isMobile ? 0 : 0))
			.text(lang.translateViz('love-hate', 'Axis--Hate'))
			.style('opacity', 0)
			.transition().duration(duration.slow).delay(duration.slow)
			.style('opacity', 1);
	}
}

function end() {
	if (drawn) {
		love = g_bubbles.selectAll('.love-bubble').data([]);
		tolerate = g_bubbles.selectAll('.tolerate-bubble').data([]);
		hate = g_bubbles.selectAll('.hate-bubble').data([]);

		// loveValue = g_text.selectAll('.lh-label--value--love').data([]);
		// tolerateValue = g_text.selectAll('.lh-label--value--tolerate').data([]);
		// hateValue = g_text.selectAll('.lh-label--value--hate').data([]);
		//
		// loveText = g_text.selectAll('.lh-label--text--love').data([]);
		// tolerateText = g_text.selectAll('.lh-label--text--tolerate').data([]);
		// hateText = g_text.selectAll('.lh-label--text--hate').data([]);

		g_text.selectAll('.lh-label--value').transition().duration(duration.fast).style('opacity', 0).remove();

		progress = g_progress.selectAll('.progress').data([]);
		progressActive = g_progress.selectAll('.progress--active').data([]);

		icons = g_bubbles.selectAll('.lh-final-icon').data(data, d => d.Phase).data([]);
		// bars = g_bubbles.selectAll('.lh-bar').data(data, d => d.Phase).data([]);
		voronoi = g_voronoi.selectAll('.lh-voronoi').data([]);

		// loveValue.exit().transition(duration.fast).style('opacity', 0).remove();
		// tolerateValue.exit().transition(duration.fast).style('opacity', 0).remove();
		// hateValue.exit().transition(duration.fast).style('opacity', 0).remove();
		//
		// loveText.exit().transition(duration.fast).style('opacity', 0).remove();
		// tolerateText.exit().transition(duration.fast).style('opacity', 0).remove();
		// hateText.exit().transition(duration.fast).style('opacity', 0).remove();

		love.exit()
			.transition().duration(duration.medium).delay((d, i) => i * 50)
			.attr('cy', y(-100))
			.remove();

		tolerate.exit()
			.transition().duration(duration.medium).delay((d, i) => i * 50)
			.attr('cy', y(-100))
			.remove();

		hate.exit()
			.transition().duration(duration.medium).delay((d, i) => 100 + i * 50)
			.attr('cy', y(-100))
			.remove();

		progress.exit()
			.transition().duration(duration.fast).delay((d, i) => i * 50)
			.attr('cx', -50)
			.remove();

		progressActive.exit()
			.transition().duration(duration.fast).delay((d, i) => i * 50)
			.attr('cx', -50)
			.remove();

		icons.exit().transition().duration(duration.fast).delay((d, i) => i * 25).style('opacity', 0).remove();
		// bars.exit().transition().duration(duration.fast).delay((d, i) => i * 25).attr('x2', d => x(4.5) + (d.Love > d.Hate ? -iconW : iconW)).remove();

		g.selectAll('.lh-axis--final, .lh-axis-label--column').transition().duration(duration.fast).style('opacity', 0).remove();

		voronoi.exit().remove();

		drawn = false;
	}
}

function resizeLH() {
	if (drawn) {
		love = g_bubbles.selectAll('.love-bubble');
		tolerate = g_bubbles.selectAll('.tolerate-bubble');
		hate = g_bubbles.selectAll('.hate-bubble');

		loveValue = g_text.selectAll('.lh-label--value--love');
		tolerateValue = g_text.selectAll('.lh-label--value--tolerate');
		hateValue = g_text.selectAll('.lh-label--value--hate');

		progress = g_progress.selectAll('.progress');
		progressActive = g_progress.selectAll('.progress--active');

		icons = g_bubbles.selectAll('.lh-final-icon').data(data, d => d.Phase);
		// bars = g_bubbles.selectAll('.lh-bar').data(data, d => d.Phase);
		voronoi = g_voronoi.selectAll('.lh-voronoi');

		let activeStep = getActiveStep(step);

		love.transition().duration(0)
			.attr('cx', x(cols.love)).attr('cy', (d, i) => step == 0 ? y(isMobile ? 200 : 75) : step == 4 ? y((i / data.length) * 100) + (y((1 / data.length) * 100)) / 2 : y(50))
			.attr('r', d => step == 0 ? util.randomNumber(20, 50) : (step == 4 ? ovrR(calcLove(d)) : r(calcLove(d))));

		tolerate.transition().duration(0)
			.attr('cx', x(cols.tolerate)).attr('cy', (d, i) => step == 0 ? y(isMobile ? 200 : 75) : step == 4 ? y((i / data.length) * 100) + (y((1 / data.length) * 100)) / 2 : y(50))
			.attr('r', d => step == 0 ? util.randomNumber(20, 50) : (step == 4 ? ovrR(d.Tolerate) : r(d.Tolerate)));

		hate.transition().duration(0)
			.attr('cx', x(cols.hate)).attr('cy', (d, i) => step == 0 ? y(isMobile ? 200 : 75) : step == 4 ? y((i / data.length) * 100) + (y((1 / data.length) * 100)) / 2 : y(50))
			.attr('r', d => step == 0 ? util.randomNumber(20, 50) : (step == 4 ? ovrR(calcHate(d)) : r(calcHate(d))));

		loveValue.transition().duration(0)
			.attr('x', x(cols.love)).attr('y', y(50)).style('font-size', d => `${font(calcLove(d))}px`);

		tolerateValue.transition().duration(0)
			.attr('x', x(cols.tolerate)).attr('y', y(50)).style('font-size', d => `${font(d.Tolerate)}px`);

		hateValue.transition().duration(0)
			.attr('x', x(cols.hate)).attr('y', y(50)).style('font-size', d => `${font(calcHate(d))}px`);

		if (step > 0) {
			progress.transition().duration(0)
				.attr('cx', x(0)).attr('cy', (d, i) => h / 2 - (progressR * 8) + (i * (progressR * 4))).attr('r', progressR)
				.style('opacity', step > 0 ? 1 : 0);

			progressActive.transition().duration(0)
				.attr('cx', x(0)).attr('cy', d => h / 2 - (progressR * 8) + (d[activeStep] * (progressR * 4))).attr('r', progressR * .5)
				.style('opacity', step > 0 ? 1 : 0);
		}

		icons.transition().duration(0)
			.attr('x', x(cols.icon) - iconW / 2).attr('y', (d, i) => y((i / data.length) * 100) + (y((1 / data.length) * 100)) / 2 - iconW / 2)
			.attr('width', iconW).attr('height', iconW);

		// bars.transition().duration(0)
		// 	.attr('x1', d => x(4.5) + (d.Love > d.Hate ? -iconW : iconW)).attr('x2', d => x(4.5) + (d.Love > d.Hate ? -iconW : iconW) + (d.Love > d.Hate ? -barX(d.Love) : barX(d.Hate)))
		// 	.attr('y1', (d, i) => y((i / data.length) * 100)).attr('y2', (d, i) => y((i / data.length) * 100));

		g_text.select('#lh-axis-final-start')
			.attr('x', w - margin.rightAxis + (isMobile ? margin.right : 0) - 60).attr('y', y((0 / data.length) * 100) + (y((1 / data.length) * 100)) / 2)
			.attr('dy', isMobile ? 4 : 7);

		g_text.select('#lh-axis-final-finish')
			.attr('x', w - margin.rightAxis + (isMobile ? margin.right : 0) - 60).attr('y', y((8 / data.length) * 100) + (y((1 / data.length) * 100)) / 2)
			.attr('dy', isMobile ? 4 : 7);

		g_text.select('#lh-axis-final-start-line')
			.attr('x1', w - margin.rightAxis + (isMobile ? margin.right : 0) - 60).attr('x2', isMobile ? x(7.5) + 5 : x(8))
			.attr('y1', y((0 / data.length) * 100) + (y((1 / data.length) * 100)) / 2).attr('y2', y((0 / data.length) * 100) + (y((1 / data.length) * 100)) / 2)

		g_text.select('#lh-axis-final-finish-line')
			.attr('x1', w - margin.rightAxis + (isMobile ? margin.right : 0) - 60).attr('x2', isMobile ? x(7.5) + 5 : x(8))
			.attr('y1', y((8 / data.length) * 100) + (y((1 / data.length) * 100)) / 2).attr('y2', y((8 / data.length) * 100) + (y((1 / data.length) * 100)) / 2)

		// if (labelsAtTop) {
		g_text.selectAll('#lh-axis-label-love-bg, #lh-axis-label-love')
			.attr('x', x(cols.love)).attr('y', y(isMobile ? 0 : 0))

		g_text.selectAll('#lh-axis-label-tolerate-bg, #lh-axis-label-tolerate')
			.attr('x', x(cols.tolerate)).attr('y', y(isMobile ? 0 : 0))

		g_text.selectAll('#lh-axis-label-hate-bg, #lh-axis-label-hate')
			.attr('x', x(cols.hate)).attr('y', y(isMobile ? 0 : 0))
		// }
	}
}

function mouseover(d, i) {
	g_bubbles.selectAll('.lh-final-icon, .love-bubble, .tolerate-bubble, .hate-bubble').filter(s => s.index != d.index).transition().duration(duration.fast).style('opacity', .5);

	g_voronoi.append('text').attr('class', 'lh-label lh-label--phase')
		.attr('x', x(cols.icon) - iconW / 2).attr('y', y((i / data.length) * 100) + (y((1 / data.length) * 100)) / 2)
		.attr('dy', 32)
		.text(lang.translateViz('love-hate', `Phase--${d.Phase}`))
		.style('opacity', 0)
		.transition().duration(duration.medium)
		.style('opacity', 1);

	g_voronoi.append('text').attr('class', 'lh-label lh-label--value')
		.attr('x', x(cols.love)).attr('y', y((i / data.length) * 100) + (y((1 / data.length) * 100)) / 2)
		.attr('dy', 8).style('font-size', `${ovrFont(calcLove(d))}px`)
		.text(formatPercent(calcLove(d)))
		.style('opacity', 0)
		.transition().duration(duration.medium)
		.style('opacity', 1);

	g_voronoi.append('text').attr('class', 'lh-label lh-label--value')
		.attr('x', x(cols.tolerate)).attr('y', y((i / data.length) * 100) + (y((1 / data.length) * 100)) / 2)
		.attr('dy', 8).style('font-size', `${ovrFont(d.Tolerate)}px`)
		.text(formatPercent(d.Tolerate))
		.style('opacity', 0)
		.transition().duration(duration.medium)
		.style('opacity', 1);

	g_voronoi.append('text').attr('class', 'lh-label lh-label--value')
		.attr('x', x(cols.hate)).attr('y', y((i / data.length) * 100) + (y((1 / data.length) * 100)) / 2)
		.attr('dy', 8).style('font-size', `${ovrFont(calcHate(d))}px`)
		.text(formatPercent(calcHate(d)))
		.style('opacity', 0)
		.transition().duration(duration.medium)
		.style('opacity', 1);
}

function mouseout() {
	g_bubbles.selectAll('.lh-final-icon, .love-bubble, .hate-bubble').transition().duration(duration.fast).style('opacity', 1);
	g_voronoi.selectAll('.lh-label--value, .lh-label--phase').transition().duration(duration.fast).style('opacity', 0).remove();
	d3.selectAll('.lh-tooltip').transition().duration(duration.fast).style('opacity', 0).remove();
}

function progressClick(d) {
	// d = d == 1 ? 2 : d;
	love_hate_steps.jumpTo(d);
}

function getActiveStep(step) {
	// return step == 2 || step == 1 ? 1 : (step == 6 || step == 5 || step == 4 || step == 3 ? 3 : (step == 9 || step == 8 || step == 7 ? 7 : 10));
	return step;
}

function filterData(d) {
	d = d.filter(d => d.Age == selectors.age && d.Sex == selectors.sex && d.Nationality == selectors.nationality);

	return d;
}

function calcLove(d) {
	return combine ? d.Love + d.Like : d.Love;
}

function calcHate(d) {
	return combine ? d.Hate + d.Dislike : d.Hate;
}

function formatPercent(value) {
	const spacer = lang.getCurrentLang() == 'de-DE' || lang.getCurrentLang() == 'es-ES' ? ' ' : '';
	return `${(value * 100).toFixed(0)}${spacer}%`;
}

function getRightMargin() {
	const fakeTextWidths = [];

	const fakeTextValues = svg.selectAll('.fake-margin-text')
		.data(['Start', 'Finish'])
		.enter()
		.append('text')
		.attr('x', -1000)
		.attr('y', -1000)
		.attr('visibility', 'hidden')
		.text(d => `${lang.translateViz('love-hate', `Axis--${d}`)}`)
		.each(function() {
			fakeTextWidths.push(d3.select(this).node().getComputedTextLength());
		});

	fakeTextValues.remove();

	return d3.max(fakeTextWidths);
}

function getBubbleParameters() {
	const bubbles = svg.selectAll('circle');

	const love = bubbles.filter(function() {
			return d3.select(this).attr('fill') == '#F8621F';
		}),
		tolerate = bubbles.filter(function() {
			return d3.select(this).attr('fill') == '#999999';
		}),
		hate = bubbles.filter(function() {
			return d3.select(this).attr('fill') == '#1F63F3';
		});

	const loveParameters = {
			x: +love.attr('cx'),
			y: +love.attr('cy'),
			r: +love.attr('r')
		},
		tolerateParameters = {
			x: +tolerate.attr('cx'),
			y: +tolerate.attr('cy'),
			r: +tolerate.attr('r')
		},
		hateParameters = {
			x: +hate.attr('cx'),
			y: +hate.attr('cy'),
			r: +hate.attr('r')
		};

	return {
		love: loveParameters,
		tolerate: tolerateParameters,
		hate: hateParameters
	}
}

function getVizParameters() {
	const rightW = rightPanel.node().offsetWidth,
		rightH = rightPanel.node().offsetHeight,
		headerH = isMobile ? 56 : 75,
		outerW = container.node().offsetWidth - (isMobile ? 0 : rightW),
		outerH = container.node().offsetHeight - (isMobile ? rightH : 0);

	const x = outerW / 2,
		y = outerH / 2;

	return {
		rightW: rightW,
		rightH: rightH,
		headerH: headerH,
		outerW: outerW,
		outerH: outerH,
		x: x,
		y: y
	};
}

export default {
	init,
	setup,
	next,
	resizeLH,
	filter,
	end
}